const WEBX_ERROR_KEYS = {
  database_not_ready: 'auth.webxErrorDatabase',
  invalid_state: 'auth.webxErrorState',
  invalid_callback: 'auth.webxErrorTicket',
  ticket_missing: 'auth.webxErrorTicket',
  ticket_expired: 'auth.webxErrorTicket',
  ticket_used: 'auth.webxErrorTicket',
  ticket_invalid: 'auth.webxErrorTicket',
  email_unverified: 'auth.webxErrorEmail',
  email_mismatch: 'auth.webxErrorEmailMismatch',
  identity_conflict: 'auth.webxErrorConflict',
  account_unavailable: 'auth.webxErrorConflict',
  account_disabled: 'auth.webxErrorConflict',
  login_required: 'auth.webxErrorLogin',
  authorization_denied: 'auth.webxLoginFailed',
  token_exchange_failed: 'auth.webxErrorTicket',
  userinfo_failed: 'auth.webxErrorService',
  sso_disabled: 'auth.webxErrorService',
  invalid_configuration: 'auth.webxErrorService',
  callback_failed: 'auth.webxErrorService'
};

export function getWebxErrorMessage(errorCode, t) {
  return t(WEBX_ERROR_KEYS[errorCode] || 'auth.webxLoginFailed');
}
